<!-- =========================================================================================
  File Name: ReportView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <vx-card title="Report">
      <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
          <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
          <v-select v-model="selectedFormat" :options="formats" class="my-4" />
          <div class="flex">
            <span class="mr-4">Cell Auto Width:</span>
            <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
          </div>
      </vs-prompt>

        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->

        <vs-table :data="rows" @selected="clickToExpand" :key="componentKey">

          <!-- <template slot="header">
            <vs-button @click="activePrompt=true">Export</vs-button>
          </template> -->

            <template slot="thead">
              <vs-th v-for="(col, k) in columns" :key="k" :colspan="condColspan(k)">{{col}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr  :data="indextr+1" :key="indextr" v-for="(row, indextr) in data" :style="condState(indextr)" :ref="'row_'+indextr" >
                  <vs-td :rowspan="condRowspan(r, row)" v-if="condRowspan(r, row)>0" v-for="(val, r) in row" :key="r+indextr" :data="val"  :ref="'cell_'+indextr+'_'+r">{{val}}</vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </vx-card>
  </div>
</template>

<script>
import Pivot from 'quick-pivot'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data() {
    return {
      componentKey: 0,
      pivotData: [],
      rowsToPivot: ['partner_name','category'],
      colsToPivot: ['payment_date'],
      aggregationDimension: 'amount',
      aggregator: 'sum',
      pivot:[],
      columns: [],
      rows: [],
      rowsObj: [],
      rawData: [],
      minRows: ['BELIY','SINIY','ZELYONNIY','KRASNIY'],
      elShown: {},
      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Id", "Email", "Username","Name", "Website"],
      headerVal: ["id", "email", "username","name", "website"],
      activePrompt: false,
      /*
      disabledFromDragDrop: ['Party Size', 'Payer Gender'],
      hiddenFromDragDrop: ['Total Bill']*/
    }
  },
  async beforeMount() {
    let records = await this.getRecords()
    this.pivotData = await this.getDataFromRecords(records)
    this.pivot = await new Pivot(this.pivotData, this.rowsToPivot, this.colsToPivot, this.aggregationDimension, this.aggregator, 'DEALER',null ,
      () => (a,b) =>{
          if(a < b) { return -1; }
          if(a > b) { return 1; }
          return 0;
      })
    this.columns = this.pivot.data.table[0].value
    this.columns.push('BALANCE')
    this.columns.push('FACT. CRED/DEB')
    this.columns.push('PROFIT')
    this.rawData = this.pivot.data.table
    let rowsTemp  = await this.getRows(this.pivot.data.table)
    this.rows = await this.createEmptyRows(rowsTemp)
    let rowsTempBal = await this.createBalance(this.rows)

    for (let i = 0; i < this.rows.length; i++) {
      if (i % 5 == 0) {
        for (let z = 1; z < 5; z++) {
          let plusVar = z + i
          let factVar = this.rows[i].length-2
          let profVar = this.rows[i].length-1
          let sledVar = i+1
          if (this.$refs['row_'+plusVar][0].$el.style.display!='none') {
            this.$refs['row_'+plusVar][0].$el.style.display='none'
            let tempRow = this.rows[i]
            tempRow[factVar] = this.rows[sledVar][factVar]
            tempRow[profVar] = this.rows[sledVar][profVar]
            this.$set(this.rows, i, tempRow)
          } else {
            this.$refs['row_'+plusVar][0].$el.style.display=''
            let tempRow = this.rows[i]
            tempRow[factVar] = ''
            tempRow[profVar] = ''
            this.$set(this.rows, i, tempRow)
          }
        } 
      } else {
        this.elShown[i] = false
      }
      let raw = this.rows[i]
      let newRaw = {}
      for (let w = 0; w < raw.length; w++) {
        const val = raw[w]
        newRaw[this.columns[w]] = val        
      }
      this.rowsObj.push(newRaw)
    }
    console.log(this.pivot.data.table)
    console.log(rowsTempBal)
    console.log('rows', this.rows)
  },
  computed: {
  },
  methods: {
    exportToExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.rowsObj
        const data = this.formatJson(this.columns, list)
        excel.export_json_to_excel({
          header: this.columns,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    },
    condState(key) {
      if (this.rows[key]!=undefined) {
        
          if (this.rows[key][1]=='KRASNIY') {
            return 'background: rgba(var(--vs-danger),.1)!important;color: rgba(var(--vs-danger),1);'
          } else if (this.rows[key][1]=='ZELYONNIY') {
            return 'background: rgba(var(--vs-success),.1)!important;color: rgba(var(--vs-success),1);'
          } else if (this.rows[key][1]=='SINIY') {
            return 'background: rgba(var(--vs-primary),.1)!important;color: rgba(var(--vs-primary),1);'
          } else {
            if (this.rows[key][0]=='Totals'||this.rows[key][0]=='') {
              return ''
            } else {
              return 'background: -webkit-gradient(linear, left top, left bottom, color-stop(44%, rgba(248, 248, 248, 0.95)), color-stop(73%, rgba(248, 248, 248, 0.46)), to(rgba(255, 255, 255, 0)))'
            }
          }   
      } else {
        return null
      }
    },
    clickToExpand(key) {
      let i = key-1
      if (i % 5 == 0) {
        console.log(this.$refs['cell_'+i+'_5'][0].data)
        for (let z = 1; z < 5; z++) {
          let plusVar = z + i
          let factVar = this.rows[i].length-2
          let profVar = this.rows[i].length-1
          let sledVar = i+1
          if (this.$refs['row_'+plusVar][0].$el.style.display!='none') {
            this.$refs['row_'+plusVar][0].$el.style.display='none'
            let tempRow = this.rows[i]
            tempRow[factVar] = this.rows[sledVar][factVar]
            tempRow[profVar] = this.rows[sledVar][profVar]
            this.$set(this.rows, i, tempRow)
          } else {
            this.$refs['row_'+plusVar][0].$el.style.display=''
            let tempRow = this.rows[i]
            tempRow[factVar] = ''
            tempRow[profVar] = ''
            this.$set(this.rows, i, tempRow)
          }
        }        
        console.log(this.rows)
      } else {
        console.log(this.$refs['row_'+i])
      }
    },
    makeClickable(i) {
      if (i % 5 == 0) {
        return 'selected'
      } else {
        return 'expandable'
      }
    },
    condRowspan(r, row){
      if (r==row.length-3) {
        if (['BELIY','ZELYONNIY'].includes(row[1])) {
          return 2          
        } else {          
          return row[0]!=''?1:0
        }
      } else if (r==row.length-2) {
        if (['BELIY'].includes(row[1])) {
          return 4          
        } else {   
          return row[0]!=''?1:0
        }
      } else if (r==row.length-1) {
        if (['BELIY'].includes(row[1])) {
          return 4          
        } else {   
          return row[0]!=''?1:0
        }
      } else {
        return 1
      }
    },
    condColspan(key) {
      return key==0?this.rowsToPivot.length:1
    },
    toggle: function(todo){
      todo.done = !todo.done
    },
    async getDataFromRecords(records){
      let data = []
      let tempRec = records.records
      
      for (let i = 0; i < records.total; i++) {
        const element = tempRec[i];

        if (i===0) {
          let firstRow = Object.keys(element)
          data.push(firstRow)
          data.push(Object.values(element))
        } else {
          data.push(Object.values(element))
        }
        
      }

      return data
    },
    async getRecords() {
        let where = "(entry_type,in,CashIn,CashOut)"
        
        let data = await this.$http.get(`https://tez.public.uz/fserver/getall/cashflowview/`, {
            params: {
                "_size": 100,
                "_p": 1,
                "_where": where,
                "_fields": "-",
                "_tableconstruction_version": "vertri",
                "_table_name": "cashflowview"
            }
        }).then(response => {
            return response.data
        })

        return data
    },
    numOr0(n){
      return parseFloat( n=='' ? 0 : isNaN(n) ? 0 : n )
    } ,
    async getRows(data) {
      let length = data.length
      let compData = []

      for (let i = 0; i < length; i++) {
        const e = data[i]
        let row = []
        let rowlength = e.value.length
        let rowData = e.value
        let rowTotal = 0
        if (e.type=='rowHeader') {
          if (e.depth==0) {
            
            for (let index = 0; index < rowlength-1; index++) {
              let element = rowData[index]
              if (index==0) {
                row.push(element)
                row.push('')
                
              } else {
                row.push(element)
                rowTotal += this.numOr0( element)  
              }
            }
            row.push(rowTotal)
            compData.push(row)
          }
        } else if (e.type=='data') {
            
          for (let index = 0; index < rowlength-1; index++) {
            let element = rowData[index]
            if (index==0) {

              row.push('')
              row.push(element)
              
            } else {
              row.push(element)
              rowTotal += this.numOr0( element)  
            }
          }
          row.push(rowTotal)
          
          compData.push(row)
          
        } else if (e.type=='aggregated') {
            
          for (let index = 0; index < rowlength-1; index++) {
            let element = rowData[index]
            if (index==0) {
              
              row.push(element)
              row.push('')
              
            } else {
              row.push(element)
              rowTotal += this.numOr0( element)  
            }
          }
            
          row.push(rowTotal)
        compData.push(row)
          
        } else {
          // for (let index = 0; index < rowlength; index++) {
          //   let element = rowData[index]
          //   row.push(element)
          // }
          //row.push(rowData)
        }

      }
      return compData
    },
    async boshRow(row, subk){
      let tRow = []
      for (let index = 0; index < row.length; index++) {
        
        if (index==1) {
          tRow.push(this.minRows[subk])
          
        } else {
          tRow.push('')
        }
      }

      return tRow
    },
    async createEmptyRows(data) {
      let dataLength = data.length
      let temp = []
      for (let i = 0; i < dataLength; i++) {
        const row = data[i]
        if (row[1]!='' && data[i-1][1]=='') {
            
          if (this.minRows.indexOf(row[1])!=0) {
            
            for (let subk = 0; subk < this.minRows.indexOf(row[1]); subk++) {
              if (this.minRows.includes(row[1])) {

                let tRow =await this.boshRow(row, subk)

                temp.push(tRow)
              }              
            }

          }
          
        }

        temp.push(row)

        if (row[1]!='') {

          for (let k = this.minRows.indexOf(row[1])+1; k < this.minRows.length; k++) {
            if (data[i+1]!=undefined) {
              if (data[i+1][1]!=this.minRows[k]) {

                if (!this.minRows.includes(data[i+1][1])) {

                  let tRow =await this.boshRow(row, k)

                  temp.push(tRow)
                  
                } else {

                  for (let subk = k; subk < this.minRows.length-k; subk++) {
                    
                    if (data[i+subk][1]!=this.minRows[subk]) {
                      // temp.push(['',this.minRows[subk]])

                      let tRow =await this.boshRow(row, subk)

                      temp.push(tRow)
                    }
                  }
                }
              }    
            } else {
              // temp.push(['',this.minRows[k]])
              let tRow =await this.boshRow(row, k)

              temp.push(tRow)
            }
          }
          
        }
        
      }
      return temp
    },
    async createBalance(data) {
      let dataLength = data.length
      let temp = []
      let profit = 0
      let creditDebit = 0
      for (let i = 0; i < dataLength; i++) {
        let row = data[i]
        let rowLastK = row.length-1
        let rowProfit = 0
        let rowCreditDebit = 0

        if (row[1]=='BELIY') {
          row.push(row[rowLastK]-data[i+1][rowLastK])
          rowCreditDebit = (data[i+2][rowLastK]-(data[i+2][rowLastK]*0.029))-row[rowLastK]
          row.push( rowCreditDebit )
          creditDebit += rowCreditDebit
          rowProfit = data[i+3][rowLastK]-data[i+1][rowLastK]
          row.push( rowProfit )
          profit += rowProfit
        } else if (row[1]=='ZELYONNIY') {
          row.push(row[rowLastK]-data[i+1][rowLastK])
          row.push('')
          row.push('')
        } else {
          if (row[0]=='Totals') {
            row.push('')
            row.push(creditDebit)
            row.push(profit)
          } else {
            row.push('')
            row.push('')
            row.push('')
          }
        }
        temp.push(row)
      }
      return temp
    }
  },
  created() {
    this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.AppActiveUser.scjw
  },
  mounted() {
  }
}
</script>

<style lang="scss">

</style>
